export class NewsletterSubmitComponent extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.init()
  }

  init() {
    const formEl = this.querySelector('.klaviyo-form')
    if (!formEl) return

    const emailInput = /** @type {HTMLInputElement | null} */ (
      this.querySelector('.email-input')
    )
    const errorMessage = this.querySelector('.error-message')
    const successMessage = this.querySelector('.success-message')

    if (!emailInput || !errorMessage) {
      console.error('Newsletter form elements not found')
      return
    }

    formEl.addEventListener('submit', async (e) => {
      e.preventDefault()

      const email = emailInput.value.trim()

      // Validate email
      if (!email) {
        errorMessage.textContent = 'Please enter an email address'
        errorMessage.classList.remove('hidden')
        return
      }

      // Hide error message on new attempt
      errorMessage.classList.add('hidden')

      // Prepare the request body
      const requestBody = new URLSearchParams({
        g: 'YpWWZ3',
        email: email,
        $consent: 'true'
      })

      try {
        const response = await fetch(
          'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: requestBody
          }
        )

        const data = await response.json()

        if (data.success) {
          // Hide form
          formEl.classList.add('opacity-0')
          formEl.classList.add('pointer-events-none')

          // Show success message
          if (successMessage) {
            setTimeout(() => {
              successMessage.classList.remove('opacity-0')
            }, 300)
          }

          // Reset form
          emailInput.value = ''
        } else {
          errorMessage.textContent =
            data.message || 'Something went wrong. Please try again.'
          errorMessage.classList.remove('hidden')
        }
      } catch (error) {
        console.error('Error submitting to Klaviyo:', error)
        errorMessage.textContent = 'Error submitting form. Please try again.'
        errorMessage.classList.remove('hidden')
      }
    })
  }
}

if (!customElements.get('newsletter-submit-component')) {
  customElements.define(
    'newsletter-submit-component',
    NewsletterSubmitComponent
  )
}
